import type { Ref } from '@/composition/vue/compositionApi'
import { useProvideInject } from '@/composition/provideInject'
import { ref } from '@/composition/vue/compositionApi'

const faqSymbol = Symbol('faq')
export const useFaqProvideInject = () => useProvideInject<Ref<string | undefined>>(faqSymbol)

export const useFaqItems = () => {
  const activeItem = ref<string>()
  useFaqProvideInject().provide(activeItem)

  return {
    activeItem,
  }
}
